var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.genres)?_c('BaseSection',{attrs:{"padded":""}},[_c(_setup.GenresList,{attrs:{"genres":_setup.genres}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }